/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./hooks/authConfig";

/**
 * Instancia de MSAL para la autenticación con Microsoft Entra.
 * Se crea una vez al inicio de la aplicación.
 */
const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Punto de entrada principal de la aplicación React.
 * Renderiza la aplicación dentro del contenedor #root del HTML.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * Renderiza la aplicación con las siguientes capas:
 * 1. React.StrictMode: Herramientas de desarrollo de React
 * 2. MsalProvider: Proveedor de autenticación Microsoft Entra
 * 3. App: Componente principal de la aplicación
 */
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
